export { useCrazyMode, KYOKI_THEME_ID } from './facade';
export type { CrazyModeState, CrazyModeActions } from './facade';
